"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLateArrivalStatus = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledLateArrivalStatus = styled_components_1.default.p `
  background: ${config_1.colors.redLight};
  border-radius: 20px;
  color: ${config_1.colors.black};
  font: ${config_1.fontSizes.small} ${config_1.fontFamilies.primary};
  height: 24px;
  padding: 4px;
  text-align: center;
  width: 40px;
`;
